
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M1.924 5.5h13.152M4.5 7.5v5m8-5v5m-4-5v5m-7-9.172c0-.457.38-.828.848-.828h12.304c.468 0 .848.37.848.828v10.344c0 .457-.38.828-.848.828H2.348a.84.84 0 0 1-.848-.828z"}})])
          )
        }
      }
    